import { Col, Row } from 'react-bootstrap';
import Css from './Customer.module.css';

export default function CustomerCount({ total = 0, active = 0 }) {
    return (
        <div className={Css.Graph_Box + ' shadow'}>
            <div className={Css.Content + ' d-flex flex-column'}>
                <div className={Css.Header}>
                    <h6>จำนวนลูกค้า (Customers)</h6>
                </div>
                <div className={Css.Content + ' d-flex flex-column flex-fill '}>
                    <Row className="mb-1 flex-fill">
                        <Col className="d-flex flex-column align-self-center">
                            <div className='flex-fill fs-4 '>{total} <span className='fs-6'>ราย</span></div>
                            <div className="text-black-50">ปัจจุบัน (Total)</div>

                        </Col>
                        <Col className="d-flex flex-column align-self-center">
                            <div className='flex-fill fs-4 text-success'>{active} <span className='fs-6'>ราย</span></div>
                            <div className="text-black-50">ใช้งานอยู่ (Active)</div>

                        </Col>
                    </Row>
                </div>
            </div>
            <div className={Css.Footer + ' d-none'}>
                <a href={'#'}>View Full Plan</a>
            </div>
        </div>
    )
}